import React from 'react';
import { Anchor } from '../../atoms';

import PageHeaderTitle from '../PageHeaderTitle';
import PageHeaderSubtitle from '../PageHeaderSubtitle';
import { Container } from './PageHeader.styles';
import { PageHeaderSize } from './type';

export type PageHeaderProps = {
  /**
   * Main page title
   */
  title?: string;
  /**
   * Page subtitle
   */
  subtitle?: string;
  /**
   * Back event handler
   */
  onBack?: () => void;
  /**
   * Previous page label
   */
  previousPageLabel?: string;
  /**
   * Header size
   */
  size?: PageHeaderSize;
};

const PageHeader = ({
  title,
  subtitle,
  onBack,
  previousPageLabel,
  size = 'medium',
}: PageHeaderProps) => {
  return (
    <div>
      {previousPageLabel && (
        <Anchor
          iconLeft="chevronLeft"
          label={previousPageLabel}
          onClick={() => onBack && onBack()}
          size={size}
        />
      )}
      <Container
        paddingTop={[3, 5]}
        paddingBottom={[3, 5]}
        alignItems={['initial', 'center']}
        gridGap={size === 'small' ? 3 : 5}
      >
        {title && <PageHeaderTitle title={title} size={size} />}
        {subtitle && <PageHeaderSubtitle subtitle={subtitle} size={size} />}
      </Container>
    </div>
  );
};

export default PageHeader;
